import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::UtilizationMethod::BottomCta::Component の Stimulus コントローラ。
// landIeul: components/UtilizationMethodsIndex/BottomCta/index.tsx の useState(active/areaId/prefectureId) 相当を再現する。
// STEP1 で土地の有無を選択 → STEP2 でエリア→都道府県を選択 → プラン請求スタートで /plan-request/ へ遷移。
interface Prefecture {
  id: string;
  name: string;
  area_id: string;
}

class SiteUtilizationMethodBottomCtaController extends Controller {
  static targets = [
    "step2",
    "step2Text",
    "areaGroup",
    "cityGroup",
    "prevButton",
    "startWrapper",
    "startButton",
  ];
  static values = { prefectures: Array, utm: String };

  declare readonly step2Target: HTMLElement;
  declare readonly step2TextTarget: HTMLElement;
  declare readonly areaGroupTarget: HTMLElement;
  declare readonly cityGroupTarget: HTMLElement;
  declare readonly prevButtonTarget: HTMLButtonElement;
  declare readonly startWrapperTarget: HTMLElement;
  declare readonly startButtonTarget: HTMLButtonElement;
  declare readonly prefecturesValue: Prefecture[];
  declare readonly utmValue: string;

  active = -1;
  areaId = "";
  prefectureId = "";

  private get activeClass(): string {
    return "UtilBottomCta_active";
  }

  private get activePartsClass(): string {
    return "UtilBottomCta_activeParts";
  }

  // STEP1: 土地の有無
  selectAnswer(event: ActionEvent): void {
    this.active = Number(event.params.answer);
    const clicked = event.currentTarget as HTMLElement;
    clicked.parentElement
      ?.querySelectorAll("button")
      .forEach((b) => b.classList.remove(this.activeClass));
    clicked.classList.add(this.activeClass);
    this.step2Target.classList.add(this.activePartsClass);
    this.areaGroupTarget
      .querySelectorAll<HTMLButtonElement>("button")
      .forEach((b) => (b.disabled = false));
    this.step2TextTarget.textContent =
      this.active === 1
        ? "土地からお探しの方は、まずはご希望のエリア、または現住所をご入力いただければ、最適なプランをご紹介します。"
        : "活用したい土地のエリアを入力してください";
  }

  // STEP2: エリア選択 → 該当都道府県ボタンを描画
  selectArea(event: ActionEvent): void {
    this.areaId = String(event.params.area);
    const clicked = event.currentTarget as HTMLElement;
    this.areaGroupTarget
      .querySelectorAll("button")
      .forEach((b) => b.classList.remove(this.activeClass));
    clicked.classList.add(this.activeClass);
    this.areaGroupTarget.style.display = "none";
    this.renderCityButtons();
    this.prevButtonTarget.disabled = false;
    this.setPrefecture("");
  }

  // STEP2: 都道府県選択
  selectPrefecture(event: ActionEvent): void {
    const clicked = event.currentTarget as HTMLElement;
    this.cityGroupTarget
      .querySelectorAll("button")
      .forEach((b) => b.classList.remove(this.activeClass));
    clicked.classList.add(this.activeClass);
    this.setPrefecture(String(event.params.pref));
  }

  // エリア選択に戻る
  resetArea(): void {
    this.areaId = "";
    this.setPrefecture("");
    this.areaGroupTarget.style.display = "";
    this.areaGroupTarget
      .querySelectorAll("button")
      .forEach((b) => b.classList.remove(this.activeClass));
    this.cityGroupTarget.innerHTML = "";
    this.prevButtonTarget.disabled = true;
  }

  // プラン請求スタート
  submit(): void {
    const propertyTypeId = this.active === 0 ? "land_usage_yes" : "land_usage_no";
    const query = `&property-type-id=${propertyTypeId}&pref-id=${this.prefectureId}`;
    const href = `/plan-request/?${this.utmValue}${query}`;
    window.open(href, "_self", "noreferrer");
  }

  private renderCityButtons(): void {
    this.cityGroupTarget.innerHTML = "";
    this.prefecturesValue
      .filter((p) => p.area_id === this.areaId)
      .forEach((p) => {
        const btn = document.createElement("button");
        btn.name = "prefecturebutton";
        btn.type = "button";
        btn.value = p.id;
        btn.textContent = p.name;
        btn.setAttribute("data-action", "site--utilization-method--bottom-cta#selectPrefecture");
        btn.setAttribute("data-site--utilization-method--bottom-cta-pref-param", p.id);
        this.cityGroupTarget.appendChild(btn);
      });
  }

  private setPrefecture(id: string): void {
    this.prefectureId = id;
    if (id) {
      this.startWrapperTarget.classList.add("UtilBottomCta_activeButton");
      this.startButtonTarget.disabled = false;
    } else {
      this.startWrapperTarget.classList.remove("UtilBottomCta_activeButton");
      this.startButtonTarget.disabled = true;
    }
  }
}

interface ActionEvent extends Event {
  params: { answer?: string; area?: string; pref?: string };
  currentTarget: EventTarget & HTMLElement;
}

application.register("site--utilization-method--bottom-cta", SiteUtilizationMethodBottomCtaController);
